import { getTempAuthCode } from 'api/get-temp-auth-code';
import { getDashboardRedirectUrl, openUrl } from '@uw/utils';

export const redirectToDashboard = async (redirectPath: string) => {
  try {
    const baseUrl = __BASE_MANAGE__;
    const tempCode = await getTempAuthCode();

    if (!tempCode) {
      return null;
    }

    const redirectUrl = getDashboardRedirectUrl(baseUrl, tempCode, redirectPath);
    openUrl(redirectUrl);
  } catch (error) {
    console.error(error);
  }
};
